import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from '~HOC';
import { Link } from 'react-router-dom';
import { flightBookingRoutes } from './utils/consts/routes';
import './ErrorBoundary.scss';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    this.setState({ hasError: true });
    // logErrorToMyService(error, errorInfo);
  }
  render() {
    const notFoundPic = require('../src/content/images/elements/not-found-page.png'),
      { children } = this.props,
      { hasError } = this.state;

    if (hasError) {
      return (
        <section className="min-vh-100 d-flex flex-row justify-content-center align-items-center">
          <div className="col-sm-10 d-flex flex-column align-items-center justify-content-center h-100">
            <div className="d-flex flex-column justify-content-center align-items-center text-start h-100">
              <div className="d-flex flex-row justify-content-center">
                <img
                  src={notFoundPic}
                  alt="404-error"
                  className={`image-size`}
                />
              </div>
              <div className="w-100 d-flex flex-column px-3">
                <span className="w-100 pt-5 pb-3 text-muted font-weight-bolder font-huge">
                  <FormattedMessage id="errorBoundary.oops" />
                </span>
                <span
                  className="w-100 pt-2 pb-5 text-muted font-xlarge"
                  style={{ lineHeight: '2.5rem' }}
                >
                  <FormattedMessage id="errorBoundary.weSearched" />
                </span>
                <div className="w-100 d-flex justify-content-center">
                  <Link
                    className="backButton mt-3 text-white cursor-pointer d-inline-block position-relative text-center m-0"
                    onClick={() => {
                      this.setState({ hasError: false });
                    }}
                    to={flightBookingRoutes.selectCity}
                  >
                    <span className="position-absolute top-key"></span>
                    <span className="text text-white d-block">
                      <FormattedMessage id="errorBoundary.backToHome" />
                    </span>
                    <span className="position-absolute bottom-key-1"></span>
                    <span className="position-absolute bottom-key-2"></span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    } else return children;
  }
}

export default withRouter(ErrorBoundary);
